var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('designated-doctor-drop-down-selector',{model:{value:(_vm.designatedDoctorInformationsSource),callback:function ($$v) {_vm.designatedDoctorInformationsSource=$$v},expression:"designatedDoctorInformationsSource"}})}
var staticRenderFns = []

export { render, staticRenderFns }